export type CompetitionSourceType = 'spin' | 'lsports' | 'heron' | 'stratos-manual' | 'stratos-feed';

// stratos:<uuid> = created manually in Stratos; stratos:<sha1> and stratos_<feed>:... = imported from a feed
const STRATOS_MANUAL = /^stratos:[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
const STRATOS_FEED = /^stratos[:_]/;

// Source is derived from the idV2 format and breaks silently if the backend changes its id conventions.
// Replace with a `source` field from getCompetitions once the backend stores it.
export const getCompetitionSource = (idV2: string | null | undefined): CompetitionSourceType | null => {
    if (idV2 === null || idV2 === undefined) {
        return null;
    }
    if (idV2.startsWith('01_')) {
        return 'spin';
    }
    if (idV2.startsWith('lsports_')) {
        return 'lsports';
    }
    if (idV2.startsWith('21_') || idV2.startsWith('HRN_')) {
        return 'heron';
    }
    if (STRATOS_MANUAL.test(idV2)) {
        return 'stratos-manual';
    }
    if (STRATOS_FEED.test(idV2)) {
        return 'stratos-feed';
    }
    return null;
};
